module.exports = __webpack_public_path__ + "img/专业版.fa0a1f01.png";